import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { fetchAthleteBadges } from "./athleteServices";

// Athlete Mode shell state: header badges (unread messages, deals needing a
// response, Atlas matches). Pages call refreshBadges() after any action
// that changes those counts.

const AthleteModeContext = createContext(null);

export const AthleteModeProvider = ({ children }) => {
  const [badges, setBadges] = useState({ unread: 0, pendingDeals: 0, atlasMatches: 0 });

  const refreshBadges = useCallback(async () => {
    try {
      const data = await fetchAthleteBadges();
      if (data) {
        setBadges({
          unread: data.unread || 0,
          pendingDeals: data.pendingDeals || 0,
          atlasMatches: data.atlasMatches || 0,
        });
      }
    } catch (err) {
      // Badges are decorative; a failed fetch must not break the shell.
    }
  }, []);

  useEffect(() => {
    refreshBadges();
    const timer = setInterval(refreshBadges, 60000);
    return () => clearInterval(timer);
  }, [refreshBadges]);

  const value = useMemo(() => ({ badges, refreshBadges }), [badges, refreshBadges]);
  return <AthleteModeContext.Provider value={value}>{children}</AthleteModeContext.Provider>;
};

export const useAthleteMode = () => {
  const ctx = useContext(AthleteModeContext);
  if (!ctx) throw new Error("useAthleteMode must be used inside AthleteModeProvider");
  return ctx;
};
